import React from 'react';
import './Footer.css';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import ProviderFooter from './ProviderFooter';

const DashboardFooter = () => {
  const { code: providerCode } = useProviderSpecificConfiguration();
  if (!providerCode) {
    return null;
  }
  return (
    <footer>
      <ProviderFooter />
    </footer>
  );
};

export default DashboardFooter;
